import React, { useEffect, useState, useCallback, useRef } from "react";
// Reusable components ------------------------------------
import AnnouncementType from "./AnnouncementType";
import AnnouncemntTemplate from "./AnnouncemntTemplate";
import LivePreview from "./LivePreview";
import QuickStatus from "./QuickStatus";
// third party library ------------------------------------
import { Col, Form, Row } from "react-bootstrap";
import ReactQuill from "react-quill";
import { useDropzone } from "react-dropzone";
import { ToastContainer, toast } from "react-toastify";
import Switch from "@mui/material/Switch";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { HexColorPicker } from "react-colorful";
import Select from "react-select";
// icons --------------------------------------------------
import { FiPlus } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaImage } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoEyeOutline } from "react-icons/io5";
import { FaCamera } from "react-icons/fa6";
import { AiFillDislike } from "react-icons/ai";
import { FaThumbsUp } from "react-icons/fa6";
import { BsChatFill } from "react-icons/bs";
import { FaReply } from "react-icons/fa6";
import { PiPencilSimpleLine } from "react-icons/pi";
import { FaSave } from "react-icons/fa";
import { GrSend } from "react-icons/gr";
import { FaFileLines } from "react-icons/fa6";
// Services -----------------------------------------
import { imageToBase64 } from "../../services/commonServices";
// Redux --------------------------------------------
import { ancemntSaveData, ancemntSaveDataOne, ancemntGetData, ancemntGetDataOne, ancemntGetDataThird, ancemntGetDataFourth, initAncemntState, getAnnouncementTitle, initAncmtTitleState, announcementInteraction, initInteractionState } from "../../redux/slices/announcementSlice";
import { createAnnouncementTypePath, updateAnnouncementTypePath, announceEmpListPath, announceEmpGroupPath, getDepartmentListPath, saveAnnouncementPath, announcementInteractionPath, recentDraftListPath, getAnnouncementTitlePath } from "../../services/config";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftLong } from "../../components/icons/Icons";
import { useNavigate } from "react-router-dom";

const AddNotification = () => {
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem("user_data")) || {}

  const dispatch = useDispatch()
  const announceStore = useSelector((state) => state.announce)
  const themeStore = useSelector((state) => state.theme)

  const containerRef = useRef(null);
  const [announcementType, setAnnouncementType] = useState(""); 
  const [announcementTypeIcon, setAnnouncementTypeIcon] = useState("");
  const [value, setValue] = useState("");
  const [descriptionCount, setDescriptionCount] = useState(0);
  const MAX_SIZE = 10 * 1024 * 1024;
  const [files, setFiles] = useState([]);
  const [taggedEmpList, setTaggedEmpList] = useState([]);
  const [taggedEmpGroupList, setTaggedEmpGroupList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [usedSize, setUsedSize] = useState(0);
  const [createAnnType, setCreateAnnType] = useState(false);
  const [isEditAnnType, setIsEditAnnType] = useState(false);
  const [isEditAnnTypeSuccess, setIsEditAnnTypeSuccess] = useState(false);
  const [validated, setValidated] = useState(false);
  const [annTypeSubject, setAnnTypeSubject] = useState("");
  const isToggleUpdateRef = useRef(false);
  // ✅ FIXED: Initialize with proper values
  const [annTypeDataObj, setAnnTypeDataObj] = useState({
    userId: user.user_id,
    announcementTitleId: "",
    announceId: "",
    subjectFlag: "0",
    bodyContent: "",
    tagPeoples: "",
    tagGroups: "",
    announceBanner: null,
    announceBnrPrev: "",
    reactionAllowId: "1",      // ✅ Default ON
    reactionDislikeId: "1",    // ✅ Default ON
    commentId: "1",            // ✅ Default ON
    repliesId: "1",            // ✅ Default ON
    approveComments: "0",      // ✅ Default OFF
    allowPushNotify: "1",      // ✅ Default ON
    pinTopFeed: "0",           // ✅ Default OFF
    allowPublishNowOrLater: "1",
    scheduleDate: "",
    scheduleTime: "",
    visiblityId: "1",
    departmentId: "",
    isSaveDraft: "",
    attachements: ""
  })
  
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedTagEmp, setSelectedTagEmp] = useState({ list: [] });

  const [color, setColor] = useState("");
  const [colorError, setColorError] = useState(false);
  const [annTypeData, setAnnTypeData] = useState({});

  const getCheckedToggleValue = (eventOrChecked) => {
    const isChecked = typeof eventOrChecked === "boolean"
      ? eventOrChecked
      : eventOrChecked?.target?.checked ?? false;
    return isChecked ? "1" : "0";
  };

  const skipFullResetRef = useRef(false);

  const [recentDraftList, setRecentDraftList] = useState([]);
  const [announcementTitleList, setAnnouncementTitleList] = useState([]);

  // Interaction state
  const [editAnnounceId, setEditAnnounceId] = useState(null);
  const [interactionCounts, setInteractionCounts] = useState({});
  const [comments, setComments] = useState([]);
  const [commentsPage, setCommentsPage] = useState(1);
  const [commentText, setCommentText] = useState("");
  const [replyText, setReplyText] = useState("");
  const [replyToId, setReplyToId] = useState(null);

  // ✅ FIXED: Toggle handlers with proper boolean conversion
const handleAllowLike = (eventOrChecked) => {
  const val = getCheckedToggleValue(eventOrChecked);
  console.log('Toggle Like:', val);
  
  setAnnTypeDataObj(prev => ({ ...prev, reactionAllowId: val }));
  isToggleUpdateRef.current = true;
  
  if (editAnnounceId) {
    const fd = new FormData();
    fd.append("userId", user.user_id);
    fd.append("announceId", editAnnounceId);
    fd.append("announcementId", editAnnounceId);
    fd.append("reactionAllowId", val);
    dispatch(ancemntSaveData({ path: saveAnnouncementPath, data: fd }));
  }
};

const handleAllowDisLike = (eventOrChecked) => {
  const val = getCheckedToggleValue(eventOrChecked);
  console.log('Toggle Dislike:', val);
  
  setAnnTypeDataObj(prev => ({ ...prev, reactionDislikeId: val }));
  isToggleUpdateRef.current = true;
  
  if (editAnnounceId) {
    const fd = new FormData();
    fd.append("userId", user.user_id);
    fd.append("announceId", editAnnounceId);
    fd.append("announcementId", editAnnounceId);
    fd.append("reactionDislikeId", val);
    dispatch(ancemntSaveData({ path: saveAnnouncementPath, data: fd }));
  }
};

const handleCommentId = (eventOrChecked) => {
  const val = getCheckedToggleValue(eventOrChecked);
  console.log('Toggle Comment:', val);
  
  setAnnTypeDataObj(prev => ({ ...prev, commentId: val }));
  isToggleUpdateRef.current = true;
  
  if (editAnnounceId) {
    const fd = new FormData();
    fd.append("userId", user.user_id);
    fd.append("announceId", editAnnounceId);
    fd.append("announcementId", editAnnounceId);
    fd.append("commentId", val);
    dispatch(ancemntSaveData({ path: saveAnnouncementPath, data: fd }));
  }
};

const handleRepliesId = (eventOrChecked) => {
  const val = getCheckedToggleValue(eventOrChecked);
  console.log('Toggle Replies:', val);
  
  setAnnTypeDataObj(prev => ({ ...prev, repliesId: val }));
  isToggleUpdateRef.current = true;
  
  if (editAnnounceId) {
    const fd = new FormData();
    fd.append("userId", user.user_id);
    fd.append("announceId", editAnnounceId);
    fd.append("announcementId", editAnnounceId);
    fd.append("repliesId", val);
    dispatch(ancemntSaveData({ path: saveAnnouncementPath, data: fd }));
  }
};

const handleApprovalCmd = (eventOrChecked) => {
  const val = getCheckedToggleValue(eventOrChecked);
  console.log('Toggle Approval:', val);
  
  setAnnTypeDataObj(prev => ({ ...prev, approveComments: val }));
  isToggleUpdateRef.current = true;
  
  if (editAnnounceId) {
    const fd = new FormData();
    fd.append("userId", user.user_id);
    fd.append("announceId", editAnnounceId);
    fd.append("announcementId", editAnnounceId);
    fd.append("approveComments", val);
    dispatch(ancemntSaveData({ path: saveAnnouncementPath, data: fd }));
  }
};

const handleAllowPushNotify = (eventOrChecked) => {
  const val = getCheckedToggleValue(eventOrChecked);
  console.log('Toggle Push Notify:', val);
  
  setAnnTypeDataObj(prev => ({ ...prev, allowPushNotify: val }));
  isToggleUpdateRef.current = true;
  
  if (editAnnounceId) {
    const fd = new FormData();
    fd.append("userId", user.user_id);
    fd.append("announceId", editAnnounceId);
    fd.append("announcementId", editAnnounceId);
    fd.append("allowPushNotify", val);
    dispatch(ancemntSaveData({ path: saveAnnouncementPath, data: fd }));
  }
};

const handlePinTopFeed = (eventOrChecked) => {
  const val = getCheckedToggleValue(eventOrChecked);
  console.log('Toggle Pin Top:', val);
  
  setAnnTypeDataObj(prev => ({ ...prev, pinTopFeed: val }));
  isToggleUpdateRef.current = true;
  
  if (editAnnounceId) {
    const fd = new FormData();
    fd.append("userId", user.user_id);
    fd.append("announceId", editAnnounceId);
    fd.append("announcementId", editAnnounceId);
    fd.append("pinTopFeed", val);
    dispatch(ancemntSaveData({ path: saveAnnouncementPath, data: fd }));
  }
};

  const handleAnnouncementTitleId = (value) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      announcementTitleId: value
    }))
  }

  const handleChangeTag = (selected) => {
    setSelectedOptions(selected || []);
    setSelectedTagEmp((pre) => ({
      ...pre,
      list: [...selectedTagEmp.list, selected]
    }))
  };

  const handleRemoveTagEmp = (value) => {
    setSelectedTagEmp((prev) => {
      const newList = prev.list.filter((item) => item.value !== value);
      if (newList.length < 1) {
        setSelectedOptions([]);
      }
      return { list: newList };
    });
  };

  const handleAnnTypeInputChange = ({ target: { name, value } }) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const getTagEmpList = useCallback(() => {
    if (!user.user_id) return

    const path1 = {
      path: announceEmpListPath,
      data: { userId: user.user_id }
    }
    const path2 = {
      path: announceEmpGroupPath,
      data: { userId: user.user_id }
    }

    dispatch(ancemntGetDataThird(path1))
    dispatch(ancemntGetDataFourth(path2))
    dispatch(ancemntGetDataOne(`${getDepartmentListPath}${user.user_id}`))
  }, [])

  useEffect(() => {
    getTagEmpList()
    getDraftList()
  }, [])

  const getDraftList = useCallback(() => {
    const formData = {
      path: recentDraftListPath,
      data: {
        "userId": user.user_id,
        "isDraft": "1"
      }
    }
    dispatch(ancemntSaveDataOne(formData))
  }, [])

  const handleSetValue = (value) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = value;
    const plainText = tempDiv.textContent || tempDiv.innerText || "";
    setDescriptionCount(plainText.length);

    if (plainText.length < 250) {
      setValue(value)
    }
  }

  const handleAnnTypeSubject = ({ target: { value } }) => {
    setAnnTypeSubject(value)
  }

  useEffect(() => {
    const container = containerRef.current;

    const handleScroll = () => {
      if (!container) return;

      const windscroll = container.scrollTop;
      const sections = container.querySelectorAll("section");

      sections.forEach((sec, i) => {
        if (sec.offsetTop <= windscroll + 50) {
          document
            .querySelectorAll("ul li a .step-num.active")
            .forEach((el) => el.classList.remove("active"));

          const li = document.querySelectorAll("ul li a .step-num")[i];
          if (li) li.classList.add("active");
        }
      });
    };

    container.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const notiHeader = [
    { id: 1, label: "Type", href: "type" },
    { id: 2, label: "Subject", href: "subject" },
    { id: 3, label: "Content", href: "content" },
    { id: 4, label: "Tags", href: "tags" },
    { id: 5, label: "Attach", href: "attach" },
    { id: 6, label: "Settings", href: "settings" },
  ];

  const editorModules = {
    toolbar: [
      ["bold", "italic", "underline"],
      ["link"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };

  const onDrop = useCallback((acceptedFiles) => {
    const newSize = acceptedFiles.reduce((acc, file) => acc + file.size, 0);

    if (usedSize + newSize > MAX_SIZE) {
      alert("Total size 10MB se zyada nahi ho sakti!");
      return;
    }

    setFiles((prev) => [
      ...prev,
      ...acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) })
      ),
    ]);
    setUsedSize((prev) => prev + newSize);
  }, [usedSize]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/*": [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".csv"],
    },
    multiple: true,
    maxSize: 10 * 1024 * 1024,
  });

  const removeFile = (name, size) => {
    setFiles((prev) => prev.filter((file) => file.name !== name));
    setUsedSize((prev) => prev - size);
  };

  const uploadEmpPhoto = async (e) => {
    const file = e.target.files[0]
    const base64File = await imageToBase64(file)
    const { name } = e.target

    setAnnTypeDataObj((pre) => {
      const updated = {
        ...pre,
        [name]: file,
        announceBnrPrev: base64File.base64,
      };
      return updated;
    });
  }

  const useTemplate = (data) => {
    console.log("mera data", data)
  }

  const [announcementCreate, setAnnouncementCreate] = useState({
    userId: user.user_id,
    announcementTitleId: "",
    announceId: "",
    announceName: "",
    announceDesc: "",
    announceImage: null,
    announceIcon: "",
    isEnableFile: "1",
  })

  const handleAnnFileChange = async (e) => {
    const base64File = await imageToBase64(e.target.files[0])

    setAnnouncementCreate((pre) => ({
      ...pre,
      [e.target.name]: e.target.files[0],
      announceIcon: base64File.base64
    }))
  };

  const handleColorCode = (color) => {
    setColor(color)
    setColorError(false)
  }

  const handleAnnIsFileEnable = (checked) => {
    setAnnouncementCreate((pre) => ({
      ...pre,
      isEnableFile: checked ? "1" : "0"
    }))
  }

  const handleCreateAnnouncementType = ({ target: { name, value } }) => {
    setAnnouncementCreate((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const handleAnnouncementTitle = ({ target: { name, value } }) => {
    const title = announcementTitleList.filter((item) => item.announcementTitleId == value)[0]?.announcementTitleName || ""
    console.log(title)
    setAnnouncementCreate((pre) => ({
      ...pre,
      [name]: value,
      announceName: title
    }))
  }

  const handleAnnTypeClicked = (data) => {
    setAnnTypeData(data)
  }

  const submitCreateAnnouncementType = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    const formData = new FormData();

    formData.append("userId", announcementCreate.userId)
    formData.append("announcementTitleId", announcementCreate.announcementTitleId)
    formData.append("announceId", announcementCreate.announceId)
    formData.append("announceName", announcementCreate.announceName)
    formData.append("announceDesc", announcementCreate.announceDesc)
    formData.append("announceImage", announcementCreate.announceImage)
    formData.append("colorCode", color)
    formData.append("isEnableFile", announcementCreate.isEnableFile)

    if (form.checkValidity() === false) {
      setValidated(true);
      if (color == "") {
        setColorError(true)
      }
    } else {
      setColorError(false)
      const form_data = {
        path: isEditAnnType ? updateAnnouncementTypePath : createAnnouncementTypePath,
        data: formData
      }
      dispatch(ancemntSaveData(form_data))
    }
  }

  const handleEditAnnouncementType = (data) => {
    setAnnouncementCreate((pre) => ({
      ...pre,
      announcementTitleId: data.announcementTitleId,
      announceId: data.announceId,
      announceName: data.announceTypeName,
      announceDesc: data.announceDesc,
      announceImage: null,
      announceIcon: data.announceIcon,
      isEnableFile: data.isEnableFile,
    }))
    setColor(data.colorCode)
  }

  const handleAnnouncementTypeModal = () => {
    dispatch(getAnnouncementTitle(getAnnouncementTitlePath))
    setCreateAnnType(true)
  }

  const handleAnnouncementTypeModalFalse = () => {
    setAnnouncementCreate((pre) => ({
      ...pre,
      userId: user.user_id,
      announcementTitleId: "",
      announceId: "",
      announceName: "",
      announceDesc: "",
      announceImage: null,
      announceIcon: "",
      isEnableFile: "1",
    }))
    setColor("")
    setColorError(false)
    setCreateAnnType(false)
    setValidated(false);
  }

  const submitCancel = () => {
    navigate("/notification");
  }

  const getToggleValue = (value, defaultValue = "0") => {
    if (value === "1") return "1";
    if (value === "2") return "2";
    if (value === "0") return "0";
    return defaultValue;
  };

const submitDraftOrPublish = (type) => {
  if (!announcementType) {
    toast.warning("Please select an announcement type");
    return;
  }
  if (!annTypeSubject.trim()) {
    toast.warning("Please enter a subject");
    return;
  }
  if (!value.trim()) {
    toast.warning("Please enter content");
    return;
  }
  if (!annTypeDataObj.announcementTitleId) {
    toast.warning("Please select an announcement title");
    return;
  }

  const sharedWith = selectedTagEmp.list.map((item) => item.value);
  
  // Use the current state values directly
  const payloadData = {
    userId: user.user_id,
    subject: annTypeSubject.trim(),
    bodyContent: value,
    announceId: announcementType,
    announcementTitleId: annTypeDataObj.announcementTitleId,
    isSaveDraft: type,
    shared_with: JSON.stringify(sharedWith),
    reactionAllowId: annTypeDataObj.reactionAllowId || "1",
    reactionDislikeId: annTypeDataObj.reactionDislikeId || "1",
    commentId: annTypeDataObj.commentId || "1",
    repliesId: annTypeDataObj.repliesId || "1",
    approveComments: annTypeDataObj.approveComments || "0",
    allowPushNotify: annTypeDataObj.allowPushNotify || "1",
    pinTopFeed: annTypeDataObj.pinTopFeed || "0",
    allowPublishNowOrLater: annTypeDataObj.allowPublishNowOrLater || "1",
    scheduleDate: annTypeDataObj.scheduleDate || "",
    scheduleTime: annTypeDataObj.scheduleTime || "",
    visiblityId: annTypeDataObj.visiblityId || "1",
    departmentId: annTypeDataObj.departmentId || "",
    ...(editAnnounceId && { announcementId: editAnnounceId }),
  };

  console.log('Submitting payload:', payloadData); // Debug log

  const formData = new FormData();
  Object.keys(payloadData).forEach(key => {
    if (payloadData[key] !== undefined && payloadData[key] !== null && payloadData[key] !== "") {
      formData.append(key, payloadData[key]);
    }
  });

  if (files && files.length > 0) {
    files.forEach((file, index) => {
      formData.append(`attachments[${index}]`, file);
    });
  }

  if (annTypeDataObj.announceBanner) {
    formData.append("supportingFile", annTypeDataObj.announceBanner);
  }

  dispatch(ancemntSaveData({
    path: saveAnnouncementPath,
    data: formData
  }));
}

// Debug effect to track annTypeDataObj changes
useEffect(() => {
  console.log('📊 annTypeDataObj changed:', {
    reactionAllowId: annTypeDataObj.reactionAllowId,
    reactionDislikeId: annTypeDataObj.reactionDislikeId,
    commentId: annTypeDataObj.commentId,
    repliesId: annTypeDataObj.repliesId,
    approveComments: annTypeDataObj.approveComments,
    allowPushNotify: annTypeDataObj.allowPushNotify,
    pinTopFeed: annTypeDataObj.pinTopFeed
  });
}, [annTypeDataObj]);

useEffect(() => {
    console.log('🔔 announceStore change:', {
      ancemntSuccess: announceStore.ancemntSuccess,
      ancemntMessage: announceStore.ancemntMessage,
      ancemntData: announceStore.ancemntData,
      isToggleUpdateRef: isToggleUpdateRef.current,
    })
  if (announceStore.ancemntSuccess) {
    // Don't show toast or reset state for toggle updates
    if (!isToggleUpdateRef.current) {
      const message = announceStore.ancemntMessage || "Announcement saved successfully";
      toast.success(message);
      
      const newEditId = announceStore.ancemntData?.announceId || announceStore.ancemntData?.announcementId || announceStore.ancemntData?.id;
      if (newEditId) {
        setEditAnnounceId(newEditId);
      }
        // If this was a real create/publish (not a draft or a toggle update), navigate back to Social Hub
        try {
          const resp = announceStore.ancemntData || {};
          const isDraftResp = resp.isSaveDraft == "1" || resp.is_save_draft == "1" || resp.isDraft == "1" || resp.is_draft == "1";
          if (!isDraftResp) {
            // give toast a moment to show before navigating
            setTimeout(() => navigate('/notification'), 700);
          }
        } catch (e) {
          // ignore
        }
    } else {
      // This is a toggle update - just log it
      console.log('Toggle update saved successfully');
    }
    
      // Reset the toggle flag
    isToggleUpdateRef.current = false;
    dispatch(initAncemntState());
  }

  if (announceStore.ancemntSuccessOne) {
    setRecentDraftList(announceStore.ancemntDataOne);
    dispatch(initAncemntState());
  }

  if (announceStore.ancemntGetThirdSuccess) {
    const newArr = announceStore.ancemntGetThirdData?.map((item) => {
      return { value: item.staffId, label: item.fullName }
    })
    setTaggedEmpList(newArr)
    dispatch(initAncemntState())
  }

  if (announceStore.ancemntGetOneSuccess) {
    setDepartmentList(announceStore.ancemntGetOneData)
    dispatch(initAncemntState())
  }

  if (announceStore.ancmtTitleSuccess) {
    setAnnouncementTitleList(announceStore.ancmtTitleData)
    dispatch(initAncmtTitleState())
  }
  }, [announceStore, editAnnounceId, navigate])

  const customStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 1600,
      width: "340px",
    }),
    control: (provided, state) => ({
      ...provided,
      border: "1px solid gray",
      borderRadius: "12px !important",
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "#fff"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fff",
    }),
    input: (provided) => ({
      ...provided,
      color: "#fff",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#aaa",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "gray"
        : state.isSelected
          ? "#90caf9"
          : "#1e1d2e",
      color: "#fff",
      cursor: "pointer",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#1e1d2e",
      color: "#fff"
    }),
  };

  const theme = themeStore.theme == "dark" ? customStyles : ""

  const goBack = () => {
    navigate("/notification")
  }

  return (
    <div className="add-notification-container">
      <div className="notification-header">
        <ul>
          {notiHeader.map((item) => (
            <li key={item.id}>
              <a href={`#${item.href}`}>
                <span className="step-num">{item.id}</span>
                <span>{item.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="notification-left-content" ref={containerRef}>
        <section className="noti-widget-bg mb-3" id="type">
          <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div className="d-flex align-items-center gap-2 color-white">
              <ArrowLeftLong class_name={"color-white cursor-pointer"} onClick={goBack} /> Back
            </div>
            <button type="button" className="universal-btn border-radius-8px" onClick={handleAnnouncementTypeModal}>
              <FiPlus /> <span style={{ position: "relative", top: "1px" }}>Add Announcement Type</span>
            </button>
          </div>

          <AnnouncemntTemplate selectTemplate={useTemplate} />

          <AnnouncementType
            announcementType={announcementType}
            handleAnnouncementTitleId={handleAnnouncementTitleId} 
            setAnnouncementType={setAnnouncementType}
            setAnnouncementTypeIcon={setAnnouncementTypeIcon}
            handleAnnTypeClicked={handleAnnTypeClicked}
            setIsEditAnnType={setIsEditAnnType}
            setCreateAnnType={setCreateAnnType}
            handleEditAnnouncementType={handleEditAnnouncementType}
            isEditAnnTypeSuccess={isEditAnnTypeSuccess}
            setIsEditAnnTypeSuccess={setIsEditAnnTypeSuccess}
          />
        </section>

        <section className="noti-widget-bg mb-3" id="subject">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
            <div style={{ width: 32, height: 32, borderRadius: '8px', background: 'linear-gradient(135deg,#8660F8,#c4b5fd)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: '#fff', fontSize: 15 }}>✏️</span>
            </div>
            <div>
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Add Subject</h3>
              <p style={{ margin: 0, fontSize: '12px', color: 'var(--secondary-text-color)' }}>Enter a subject line for your announcement</p>
            </div>
          </div>

          <div style={{ marginTop: '20px' }}>
            <label style={{ fontSize: '12px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '8px' }}>
              Subject Line
            </label>
            <div style={{ position: 'relative' }}>
              <input
                name="annTypeSubject"
                value={annTypeSubject}
                onChange={handleAnnTypeSubject}
                className="universal-input"
                style={{ width: '100%', paddingLeft: '16px', paddingRight: '80px' }}
                placeholder="e.g. 🎉 Happy Diwali to all employees!"
              />
              {annTypeSubject && (
                <span style={{
                  position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                  fontSize: '11px', color: annTypeSubject.length > 80 ? '#F87171' : '#4ADE80',
                  fontWeight: 600, background: 'var(--noti-widget-bg)',
                  padding: '2px 6px', borderRadius: '6px'
                }}>
                  {annTypeSubject.length}/100
                </span>
              )}
            </div>
          </div>
        </section>

        <section className="noti-widget-bg mb-3" id="content">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: 32, height: 32, borderRadius: '8px', background: 'linear-gradient(135deg,#8660F8,#c4b5fd)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ color: '#fff', fontSize: 14 }}>📝</span>
              </div>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Body Content</h3>
                <p style={{ margin: 0, fontSize: '12px', color: 'var(--secondary-text-color)' }}>Create your announcement with rich formatting</p>
              </div>
            </div>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              padding: '4px 12px', borderRadius: '20px',
              background: descriptionCount > 200 ? '#EF444420' : descriptionCount > 100 ? '#EAB30820' : '#22C55E20',
              border: `1px solid ${descriptionCount > 200 ? '#EF444440' : descriptionCount > 100 ? '#EAB30840' : '#22C55E40'}`,
            }}>
              <span style={{ fontSize: '12px', fontWeight: 700, color: descriptionCount > 200 ? '#F87171' : descriptionCount > 100 ? '#FDE047' : '#4ADE80' }}>
                {descriptionCount}
              </span>
              <span style={{ fontSize: '12px', color: 'var(--secondary-text-color)' }}>/250</span>
            </div>
          </div>

          <ReactQuill
            theme="snow"
            value={value}
            onChange={handleSetValue}
            modules={editorModules}
            placeholder="Write your announcement content here..."
            className="color-white mt-4"
          />
        </section>

        <section className="noti-widget-bg mb-3" id="tags">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
            <div style={{ width: 32, height: 32, borderRadius: '8px', background: 'linear-gradient(135deg,#3B82F6,#93C5FD)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: '#fff', fontSize: 14 }}>👥</span>
            </div>
            <div>
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Tag People</h3>
              <p style={{ margin: 0, fontSize: '12px', color: 'var(--secondary-text-color)' }}>Mention specific employees or teams (optional)</p>
            </div>
          </div>

          <label style={{ fontSize: '12px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '8px' }}>
            Tag Employees
          </label>
          <Select
            options={taggedEmpList}
            value={selectedOptions}
            onChange={handleChangeTag}
            placeholder="🔍 Search and mention employees..."
            classNamePrefix="custom"
            styles={theme}
          />

          {selectedTagEmp.list.length > 0 && (
            <div style={{ marginTop: '16px' }}>
              <label style={{ fontSize: '12px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '10px' }}>
                Tagged People ({selectedTagEmp.list.length})
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {selectedTagEmp.list?.map((item) => (
                  <button
                    type="button"
                    key={item.value}
                    onClick={() => handleRemoveTagEmp(item.value)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: '6px',
                      padding: '5px 12px 5px 8px', borderRadius: '20px',
                      background: '#3B82F620', border: '1px solid #3B82F640',
                      color: '#93C5FD', fontSize: '13px', cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    <div style={{ width: 20, height: 20, borderRadius: '50%', background: '#3B82F640', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700, color: '#93C5FD' }}>
                      {item.label?.charAt(0)?.toUpperCase()}
                    </div>
                    {item.label}
                    <RxCross2 style={{ fontSize: 12, color: '#60A5FA' }} />
                  </button>
                ))}
              </div>
            </div>
          )}
        </section>

        <section className="noti-widget-bg mb-3" id="attach">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
            <div style={{ width: 32, height: 32, borderRadius: '8px', background: 'linear-gradient(135deg,#22C55E,#86EFAC)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: '#fff', fontSize: 14 }}>📎</span>
            </div>
            <div>
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Attachments</h3>
              <p style={{ margin: 0, fontSize: '12px', color: 'var(--secondary-text-color)' }}>Upload images, documents, or other files (optional)</p>
            </div>
            {files.length > 0 && (
              <span style={{ marginLeft: 'auto', padding: '3px 10px', borderRadius: '20px', background: '#22C55E20', border: '1px solid #22C55E40', fontSize: '12px', color: '#4ADE80', fontWeight: 600 }}>
                {files.length} file{files.length > 1 ? 's' : ''} added
              </span>
            )}
          </div>

          <div
            {...getRootProps()}
            style={{
              border: `2px dashed ${isDragActive ? '#8660F8' : 'var(--ann-item-border)'}`,
              borderRadius: '14px', padding: '40px 20px', textAlign: 'center',
              cursor: 'pointer', transition: 'all 0.2s',
              background: isDragActive ? '#8660F810' : 'var(--noti-widget-bg)',
            }}
          >
            <input {...getInputProps()} />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: 56, height: 56, borderRadius: '14px', background: isDragActive ? '#8660F830' : '#8660F815', border: `1px solid ${isDragActive ? '#8660F860' : '#8660F830'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px' }}>
                <FaCloudUploadAlt style={{ color: isDragActive ? '#c4b5fd' : '#8660F8' }} />
              </div>
              <div>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                  {isDragActive ? 'Drop files here...' : 'Drag & drop files here'}
                </p>
                <p style={{ margin: '4px 0 0', fontSize: '12px', color: 'var(--secondary-text-color)' }}>
                  or <span style={{ color: '#8660F8', fontWeight: 600 }}>click to browse</span>
                </p>
              </div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
                {['PDF', 'DOC', 'EXCEL', 'CSV'].map(t => (
                  <span key={t} style={{ padding: '2px 8px', borderRadius: '6px', background: 'var(--noti-widget-bg)', border: '1px solid var(--ann-item-border)', fontSize: '11px', color: 'var(--secondary-text-color)' }}>{t}</span>
                ))}
                <span style={{ padding: '2px 8px', borderRadius: '6px', background: '#EAB30815', border: '1px solid #EAB30830', fontSize: '11px', color: '#FDE047' }}>Max 10MB</span>
              </div>
            </div>
          </div>

          {files.length > 0 && (
            <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {files.map((file) => {
                const fileURL = URL.createObjectURL(file)
                return (
                  <div key={file.name} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '12px 14px', borderRadius: '10px',
                    background: '#22C55E10', border: '1px solid #22C55E25',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{ width: 36, height: 36, borderRadius: '8px', background: '#22C55E20', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <FaImage style={{ color: '#4ADE80', fontSize: 16 }} />
                      </div>
                      <div>
                        <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>{file.name}</p>
                        <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>{(file.size / (1024 * 1024)).toFixed(2)} MB</p>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <a href={fileURL} target="_blank" rel="noopener noreferrer" style={{ width: 32, height: 32, borderRadius: '8px', background: '#3B82F620', border: '1px solid #3B82F640', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IoEyeOutline style={{ color: '#60A5FA', fontSize: 15 }} />
                      </a>
                      <button onClick={() => removeFile(file.name, file.size)} style={{ width: 32, height: 32, borderRadius: '8px', background: '#EF444420', border: '1px solid #EF444440', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                        <RiDeleteBinLine style={{ color: '#F87171', fontSize: 15 }} />
                      </button>
                    </div>
                  </div>
                )
              })}
            </div>
          )}

          {annTypeDataObj.isEnableFile === "1" && (
            <div style={{ marginTop: '16px', padding: '16px', borderRadius: '12px', background: '#9D7BFF10', border: '1px solid #9D7BFF25' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <FaCamera style={{ color: '#9D7BFF', fontSize: 18 }} />
                <div>
                  <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Upload Photo</p>
                  <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>For employee appreciation posts</p>
                </div>
              </div>
              <label htmlFor="up-photo" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '8px 18px', borderRadius: '8px', background: '#9D7BFF20', border: '1px solid #9D7BFF50', color: '#c4b5fd', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>
                Select Photo
              </label>
              <input type="file" name="announceBanner" id="up-photo" onChange={uploadEmpPhoto} style={{ display: 'none' }} />
            </div>
          )}
        </section>

        <section id="settings" className="p-0">
          {/* Interaction Settings */}
          <div className="noti-widget-bg padding-2rem">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <div style={{ width: 32, height: 32, borderRadius: '8px', background: 'linear-gradient(135deg,#F97316,#FDBA74)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ color: '#fff', fontSize: 14 }}>⚙️</span>
              </div>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Interaction Settings</h3>
                <p style={{ margin: 0, fontSize: '12px', color: 'var(--secondary-text-color)' }}>Configure how employees can interact</p>
              </div>
            </div>

            {/* DEBUG: show toggle state for troubleshooting - remove in production */}
            <div style={{ marginTop: 8, marginBottom: 12, fontSize: 12, color: '#cbd5e1' }}>
              <strong style={{ display: 'block', marginBottom: 6 }}>Debug: toggle values</strong>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <div>likes: {annTypeDataObj.reactionAllowId || '""'}</div>
                <div>dislikes: {annTypeDataObj.reactionDislikeId || '""'}</div>
                <div>comments: {annTypeDataObj.commentId || '""'}</div>
                <div>replies: {annTypeDataObj.repliesId || '""'}</div>
                <div>approveComments: {annTypeDataObj.approveComments || '""'}</div>
                <div>pushNotify: {annTypeDataObj.allowPushNotify || '""'}</div>
                <div>pinTop: {annTypeDataObj.pinTopFeed || '""'}</div>
              </div>
            </div>

            <p style={{ fontSize: '11px', fontWeight: 700, color: 'var(--secondary-text-color)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '12px' }}>Reactions</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
              {/* Allow Likes Toggle */}
              <div style={{ 
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                padding: '14px', borderRadius: '12px', 
                background: annTypeDataObj.reactionAllowId === "1" ? '#4ADE8010' : 'var(--noti-widget-bg)', 
                border: `1px solid ${annTypeDataObj.reactionAllowId === "1" ? '#4ADE8040' : 'var(--noti-widget-border)'}`,
                transition: 'all 0.2s'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: 36, height: 36, borderRadius: '9px', background: '#22C55E20', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: '#4ADE80' }}>
                    <FaThumbsUp />
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Allow Likes</p>
                    <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>Let employees like this post</p>
                  </div>
                </div>
                <Switch 
                  checked={annTypeDataObj.reactionAllowId === "1"} 
                  onChange={(event, checked) => { console.log('Switch allowLikes raw:', { checked, targetChecked: event?.target?.checked }); handleAllowLike(checked); }}
                  onClick={() => handleAllowLike(annTypeDataObj.reactionAllowId !== "1")}
                />
              </div>

              {/* Allow Dislikes Toggle */}
              <div style={{ 
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                padding: '14px', borderRadius: '12px', 
                background: annTypeDataObj.reactionDislikeId === "1" ? '#F8717110' : 'var(--noti-widget-bg)', 
                border: `1px solid ${annTypeDataObj.reactionDislikeId === "1" ? '#F8717140' : 'var(--noti-widget-border)'}`,
                transition: 'all 0.2s'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: 36, height: 36, borderRadius: '9px', background: '#EF444420', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: '#F87171' }}>
                    <AiFillDislike />
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Allow Dislikes</p>
                    <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>Let employees dislike this post</p>
                  </div>
                </div>
                <Switch 
                  checked={annTypeDataObj.reactionDislikeId === "1"} 
                  onChange={(event, checked) => { console.log('Switch allowDislikes raw:', { checked, targetChecked: event?.target?.checked }); handleAllowDisLike(checked); }}
                  onClick={() => handleAllowDisLike(annTypeDataObj.reactionDislikeId !== "1")}
                />
              </div>
            </div>

            <p style={{ fontSize: '11px', fontWeight: 700, color: 'var(--secondary-text-color)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '12px' }}>Comments & Replies</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
              {/* Allow Comments Toggle */}
              <div style={{ 
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                padding: '14px', borderRadius: '12px', 
                background: annTypeDataObj.commentId === "1" ? '#60A5FA10' : 'var(--noti-widget-bg)', 
                border: `1px solid ${annTypeDataObj.commentId === "1" ? '#60A5FA40' : 'var(--noti-widget-border)'}`,
                transition: 'all 0.2s'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: 36, height: 36, borderRadius: '9px', background: '#3B82F620', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: '#60A5FA' }}>
                    <BsChatFill />
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Allow Comments</p>
                    <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>Let employees comment</p>
                  </div>
                </div>
                <Switch 
                  checked={annTypeDataObj.commentId === "1"} 
                  onChange={(event, checked) => { console.log('Switch comments raw:', { checked, targetChecked: event?.target?.checked }); handleCommentId(checked); }}
                  onClick={() => handleCommentId(annTypeDataObj.commentId !== "1")}
                />
              </div>

              {/* Allow Replies Toggle */}
              <div style={{ 
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                padding: '14px', borderRadius: '12px', 
                background: annTypeDataObj.repliesId === "1" ? '#C084FC10' : 'var(--noti-widget-bg)', 
                border: `1px solid ${annTypeDataObj.repliesId === "1" ? '#C084FC40' : 'var(--noti-widget-border)'}`,
                transition: 'all 0.2s'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: 36, height: 36, borderRadius: '9px', background: '#A855F720', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: '#C084FC' }}>
                    <FaReply />
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Allow Replies</p>
                    <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>Let employees reply</p>
                  </div>
                </div>
                <Switch 
                  checked={annTypeDataObj.repliesId === "1"} 
                  onChange={(event, checked) => { console.log('Switch replies raw:', { checked, targetChecked: event?.target?.checked }); handleRepliesId(checked); }}
                  onClick={() => handleRepliesId(annTypeDataObj.repliesId !== "1")}
                />
              </div>
            </div>

            <p style={{ fontSize: '11px', fontWeight: 700, color: 'var(--secondary-text-color)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '12px' }}>Advanced</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {/* Require Approval Toggle */}
              <div style={{ 
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                padding: '12px 14px', borderRadius: '10px', 
                background: annTypeDataObj.approveComments === "1" ? '#EAB30810' : 'var(--noti-widget-bg)', 
                border: `spx solid ${annTypeDataObj.approveComments === "1" ? '#EAB30840' : 'var(--noti-widget-border)'}`,
                transition: 'all 0.2s'
              }}>
                <div>
                  <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Require approval for comments</p>
                  <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>Comments need approval before appearing</p>
                </div>
                <Switch 
                  checked={annTypeDataObj.approveComments === "1"} 
                  onChange={(event, checked) => { console.log('Switch approval raw:', { checked, targetChecked: event?.target?.checked }); handleApprovalCmd(checked); }}
                  onClick={() => handleApprovalCmd(annTypeDataObj.approveComments !== "1")}
                />
              </div>

              {/* Push Notifications Toggle */}
              <div style={{ 
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                padding: '12px 14px', borderRadius: '10px', 
                background: annTypeDataObj.allowPushNotify === "1" ? '#8660F810' : 'var(--noti-widget-bg)', 
                border: `1px solid ${annTypeDataObj.allowPushNotify === "1" ? '#8660F840' : 'var(--noti-widget-border)'}`,
                transition: 'all 0.2s'
              }}>
                <div>
                  <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Send push notifications</p>
                  <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>Notify all tagged employees immediately</p>
                </div>
                <Switch 
                  checked={annTypeDataObj.allowPushNotify === "1"} 
                  onChange={(event, checked) => { console.log('Switch pushNotify raw:', { checked, targetChecked: event?.target?.checked }); handleAllowPushNotify(checked); }}
                  onClick={() => handleAllowPushNotify(annTypeDataObj.allowPushNotify !== "1")}
                />
              </div>

              {/* Pin to Top Toggle */}
              <div style={{ 
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                padding: '12px 14px', borderRadius: '10px', 
                background: annTypeDataObj.pinTopFeed === "1" ? '#F9731610' : 'var(--noti-widget-bg)', 
                border: `1px solid ${annTypeDataObj.pinTopFeed === "1" ? '#F9731640' : 'var(--noti-widget-border)'}`,
                transition: 'all 0.2s'
              }}>
                <div>
                  <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Pin to top of feed</p>
                  <p style={{ margin: 0, fontSize: '11px', color: 'var(--secondary-text-color)' }}>Keep this announcement at the top</p>
                </div>
                <Switch 
                  checked={annTypeDataObj.pinTopFeed === "1"} 
                  onChange={(event, checked) => { console.log('Switch pinTop raw:', { checked, targetChecked: event?.target?.checked }); handlePinTopFeed(checked); }}
                  onClick={() => handlePinTopFeed(annTypeDataObj.pinTopFeed !== "1")}
                />
              </div>
            </div>
          </div>

          {/* Publishing Options */}
          <div className="noti-widget-bg mt-3 padding-2rem">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <div style={{ width: 32, height: 32, borderRadius: '8px', background: 'linear-gradient(135deg,#8660F8,#c4b5fd)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ color: '#fff', fontSize: 14 }}>🚀</span>
              </div>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Publishing Options</h3>
                <p style={{ margin: 0, fontSize: '12px', color: 'var(--secondary-text-color)' }}>Choose when and how to publish</p>
              </div>
            </div>
            <Row>
              <Col sm="6">
                <p style={{ fontSize: '11px', fontWeight: 700, color: 'var(--secondary-text-color)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '12px' }}>Schedule</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', borderRadius: '10px', background: annTypeDataObj.allowPublishNowOrLater === "1" ? '#8660F815' : 'var(--noti-widget-bg)', border: `1px solid ${annTypeDataObj.allowPublishNowOrLater === "1" ? '#8660F850' : 'var(--noti-widget-border)'}`, cursor: 'pointer' }}>
                    <input type="radio" name="allowPublishNowOrLater" value="1" checked={annTypeDataObj.allowPublishNowOrLater === "1"} onChange={handleAnnTypeInputChange} style={{ width: '15px', height: '15px', accentColor: '#8660F8', cursor: 'pointer', margin: 0 }} />
                    <span style={{ fontSize: '13px', color: 'var(--primary-text-color)', fontWeight: 500 }}>⚡ Publish Now</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', borderRadius: '10px', background: annTypeDataObj.allowPublishNowOrLater === "2" ? '#8660F815' : 'var(--noti-widget-bg)', border: `1px solid ${annTypeDataObj.allowPublishNowOrLater === "2" ? '#8660F850' : 'var(--noti-widget-border)'}`, cursor: 'pointer' }}>
                    <input type="radio" name="allowPublishNowOrLater" value="2" checked={annTypeDataObj.allowPublishNowOrLater === "2"} onChange={handleAnnTypeInputChange} style={{ width: '15px', height: '15px', accentColor: '#8660F8', cursor: 'pointer', margin: 0 }} />
                    <span style={{ fontSize: '13px', color: 'var(--primary-text-color)', fontWeight: 500 }}>🕐 Schedule for later</span>
                  </label>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '14px' }}>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: 600, color: 'var(--secondary-text-color)', display: 'block', marginBottom: '6px' }}>DATE</label>
                    <Form.Control type="date" name="scheduleDate" value={annTypeDataObj.scheduleDate} onChange={handleAnnTypeInputChange} className="universal-input" />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: 600, color: 'var(--secondary-text-color)', display: 'block', marginBottom: '6px' }}>TIME</label>
                    <Form.Control type="time" name="scheduleTime" value={annTypeDataObj.scheduleTime} onChange={handleAnnTypeInputChange} className="universal-input" />
                  </div>
                </div>
              </Col>
              <Col sm="6">
                <p style={{ fontSize: '11px', fontWeight: 700, color: 'var(--secondary-text-color)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '12px' }}>Visibility</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', borderRadius: '10px', background: annTypeDataObj.visiblityId === "1" ? '#8660F815' : 'var(--noti-widget-bg)', border: `1px solid ${annTypeDataObj.visiblityId === "1" ? '#8660F850' : 'var(--noti-widget-border)'}`, cursor: 'pointer' }}>
                    <input type="radio" name="visiblityId" value="1" checked={annTypeDataObj.visiblityId === "1"} onChange={handleAnnTypeInputChange} style={{ width: '15px', height: '15px', accentColor: '#8660F8', cursor: 'pointer', margin: 0 }} />
                    <span style={{ fontSize: '13px', color: 'var(--primary-text-color)', fontWeight: 500 }}>🌐 Everyone in company</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', borderRadius: '10px', background: annTypeDataObj.visiblityId === "2" ? '#8660F815' : 'var(--noti-widget-bg)', border: `1px solid ${annTypeDataObj.visiblityId === "2" ? '#8660F850' : 'var(--noti-widget-border)'}`, cursor: 'pointer' }}>
                    <input type="radio" name="visiblityId" value="2" checked={annTypeDataObj.visiblityId === "2"} onChange={handleAnnTypeInputChange} style={{ width: '15px', height: '15px', accentColor: '#8660F8', cursor: 'pointer', margin: 0 }} />
                    <span style={{ fontSize: '13px', color: 'var(--primary-text-color)', fontWeight: 500 }}>🏢 Specific Departments</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', borderRadius: '10px', background: annTypeDataObj.visiblityId === "3" ? '#8660F815' : 'var(--noti-widget-bg)', border: `1px solid ${annTypeDataObj.visiblityId === "3" ? '#8660F850' : 'var(--noti-widget-border)'}`, cursor: 'pointer' }}>
                    <input type="radio" name="visiblityId" value="3" checked={annTypeDataObj.visiblityId === "3"} onChange={handleAnnTypeInputChange} style={{ width: '15px', height: '15px', accentColor: '#8660F8', cursor: 'pointer', margin: 0 }} />
                    <span style={{ fontSize: '13px', color: 'var(--primary-text-color)', fontWeight: 500 }}>👥 Only Tagged people</span>
                  </label>
                </div>
                <div style={{ marginTop: '14px' }}>
                  <label style={{ fontSize: '11px', fontWeight: 600, color: 'var(--secondary-text-color)', display: 'block', marginBottom: '6px' }}>DEPARTMENT</label>
                  <Form.Select className="universal-input" name="departmentId" value={annTypeDataObj.departmentId} onChange={handleAnnTypeInputChange}>
                    <option value="">All Departments</option>
                    {departmentList?.map((item) => (
                      <option key={item.departmentId} value={item.departmentId}>{item.department_name}</option>
                    ))}
                  </Form.Select>
                </div>
              </Col>
            </Row>
          </div>

          {recentDraftList?.length > 0 && (
            <div className="noti-widget-bg mt-3 padding-2rem">
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                <div style={{ width: 32, height: 32, borderRadius: '8px', background: 'linear-gradient(135deg,#EAB308,#FDE047)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ color: '#fff', fontSize: 14 }}>📋</span>
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--primary-text-color)' }}>Recent Drafts</h3>
                  <p style={{ margin: 0, fontSize: '12px', color: 'var(--secondary-text-color)' }}>Continue where you left off</p>
                </div>
                <span style={{ marginLeft: 'auto', padding: '3px 12px', borderRadius: '20px', background: '#EAB30820', border: '1px solid #EAB30840', fontSize: '12px', color: '#FDE047', fontWeight: 600 }}>
                  {recentDraftList.length} record{recentDraftList.length > 1 ? 's' : ''}
                </span>
              </div>

              <Row>
                {recentDraftList?.map((item) => {
                  const typeName = item.announceTypeName || item.titleName || 'General'
                  const typeIcon = item.announceTypeIcon || null
                  const subject = item.subject || 'Untitled'
                  const body = item.bodyContent || ''
                  const isDraft = item.is_draft === 2 || item.is_draft === "2"
                  const hasSchedule = item.schedule_date && item.schedule_date !== ""
                  const attachCount = Array.isArray(item.attachments) ? item.attachments.length : 0

                  const BADGE_COLORS = {
                    'Birthdays':   { bg: '#EC489920', border: '#EC489940', text: '#F9A8D4' },
                    'Festival':    { bg: '#F9731620', border: '#F9731640', text: '#FDBA74' },
                    'Anniversary': { bg: '#A855F720', border: '#A855F740', text: '#C084FC' },
                    'Onboarding':  { bg: '#22C55E20', border: '#22C55E40', text: '#86EFAC' },
                    'Sales':       { bg: '#3B82F620', border: '#3B82F640', text: '#93C5FD' },
                  }
                  const badge = BADGE_COLORS[typeName] || { bg: '#8660F820', border: '#8660F840', text: '#c4b5fd' }

                  return (
                    <Col sm="4" className="p-1" key={item.id}>
                      <div
                        style={{
                          padding: '14px', borderRadius: '12px', minHeight: '210px',
                          background: 'var(--noti-widget-bg)',
                          border: `1px solid ${isDraft ? '#EAB30840' : 'var(--noti-widget-border)'}`,
                          display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
                          cursor: 'pointer', transition: 'all 0.2s', position: 'relative', overflow: 'hidden'
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                          <div style={{ width: 34, height: 34, borderRadius: '8px', background: badge.bg, border: `1px solid ${badge.border}`, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0 }}>
                            {typeIcon ? <img src={typeIcon} style={{ width: 22, height: 22, objectFit: 'contain' }} alt="" /> : <span style={{ fontSize: 16 }}>📝</span>}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            {isDraft && <span style={{ padding: '2px 7px', borderRadius: '6px', background: '#EAB30820', border: '1px solid #EAB30840', fontSize: '10px', color: '#FDE047', fontWeight: 700 }}>DRAFT</span>}
                            {hasSchedule && <span style={{ padding: '2px 7px', borderRadius: '6px', background: '#8660F820', border: '1px solid #8660F840', fontSize: '10px', color: '#c4b5fd', fontWeight: 600 }}>🕐 {item.schedule_date}</span>}
                          </div>
                        </div>

                        <p style={{ margin: '0 0 5px', fontSize: '13px', fontWeight: 700, color: 'var(--primary-text-color)', lineHeight: 1.4 }}>{subject}</p>

                        <p style={{ margin: '0 0 10px', fontSize: '11px', color: 'var(--secondary-text-color)', lineHeight: 1.5, flex: 1 }} dangerouslySetInnerHTML={{ __html: body || '<em>No content</em>' }} />

                        {attachCount > 0 && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '8px' }}>
                            <span style={{ fontSize: '11px', color: 'var(--secondary-text-color)' }}>📎 {attachCount} attachment{attachCount > 1 ? 's' : ''}</span>
                          </div>
                        )}

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <span style={{ padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 600, background: badge.bg, border: `1px solid ${badge.border}`, color: badge.text }}>
                            {typeName}
                          </span>
                          <button
                            title="Continue editing this draft"
                            onClick={() => {
                              setAnnTypeSubject(item.subject || '')
                              setValue(item.bodyContent || '')
                              if (item.announceTypeId) setAnnouncementType(item.announceTypeId)
                              // ✅ Set the announcement ID for editing
                              setEditAnnounceId(item.id || item.announceId || item.announcement_id || item.announce_id)
                              // ✅ Load interaction settings from saved announcement
                              setAnnTypeDataObj(prev => ({
                                ...prev,
                                reactionAllowId: item.reactionAllowId || "1",
                                reactionDislikeId: item.reactionDislikeId || "1",
                                commentId: item.commentId || "1",
                                repliesId: item.repliesId || "1",
                                approveComments: item.approveComments || "0",
                                allowPushNotify: item.allowPushNotify || "1",
                                pinTopFeed: item.pinTopFeed || "0"
                              }))
                            }}
                            style={{ width: 30, height: 30, borderRadius: '8px', background: '#8660F820', border: '1px solid #8660F840', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                          >
                            <PiPencilSimpleLine style={{ color: '#c4b5fd', fontSize: 14 }} />
                          </button>
                        </div>
                      </div>
                    </Col>
                  )
                })}
              </Row>
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderRadius: '14px', background: 'var(--noti-widget-bg)', border: '1px solid var(--noti-widget-border)', marginTop: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: 'var(--secondary-text-color)' }}>
              <FaSave style={{ color: '#4ADE80' }} />
              <span>Auto saved 2 minutes ago</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <button type="button" onClick={submitCancel} style={{ padding: '9px 20px', borderRadius: '8px', background: 'transparent', border: '1px solid var(--ann-item-border)', color: 'var(--secondary-text-color)', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>
                Cancel
              </button>
              <button type="button" onClick={() => submitDraftOrPublish("1")} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 20px', borderRadius: '8px', background: '#EAB30820', border: '1px solid #EAB30840', color: '#FDE047', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>
                <FaFileLines /> Save as Draft
              </button>
              <button type="button" onClick={() => submitDraftOrPublish("2")} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 24px', borderRadius: '8px', background: 'linear-gradient(135deg,#8660F8,#c4b5fd)', border: 'none', color: '#fff', fontSize: '13px', fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 14px #8660F840' }}>
                <GrSend /> Publish Announcement
              </button>
            </div>
          </div>
        </section>
      </div>

      <div className="notification-right-content">
        <LivePreview
          icon={announcementTypeIcon}
          annTypeData={annTypeData}
          subject={annTypeSubject}
          anntypeDes={value}
          selectedTagEmp={selectedTagEmp.list}
          banner={annTypeDataObj.announceBnrPrev}
          reactionAllowId={annTypeDataObj.reactionAllowId}
          reactionDislikeId={annTypeDataObj.reactionDislikeId}
          commentId={annTypeDataObj.commentId}
          repliesId={annTypeDataObj.repliesId}
          approveComments={annTypeDataObj.approveComments}
        />
        <QuickStatus selectedTagEmp={selectedTagEmp.list.length} descriptionCount={descriptionCount} attachmentsCount={files.length} />
      </div>

      <Dialog fullWidth={true} maxWidth={"sm"} open={createAnnType} onClose={handleAnnouncementTypeModalFalse} className="dark-bg-color">
        <Form noValidate validated={validated} onSubmit={submitCreateAnnouncementType} encType="multipart/form-data">
          <DialogTitle className="dialog-title">
            <div className="dialog-title-icon">
              <span className="close-icon" onClick={handleAnnouncementTypeModalFalse}>X</span>
              <span className="title">{isEditAnnType ? "Update Announcement" : "Create Announcement"}</span>
            </div>
            <button className="universal-btn" style={{ padding: "0 15px", borderRadius: "8px", fontSize: "15px" }} type="submit">
              {isEditAnnType ? "Update" : "Create"}
            </button>
          </DialogTitle>
          <DialogContent>
            <Row className="mt-3">
              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Announcment Title</Form.Label>
                  <Form.Select name={"announcementTitleId"} value={announcementCreate.announcementTitleId} onChange={handleAnnouncementTitle} className="universal-input" required>
                    <option value={""}>Select Announcement Title</option>
                    {announcementTitleList.map(list => <option value={list.announcementTitleId} key={list.announcementTitleId}>{list.announcementTitleName}</option>)}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">Announcement type is requird</Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Announcment Type</Form.Label>
                  <Form.Control name={"announceName"} value={announcementCreate.announceName} placeholder={"Enter Announcment Type here"} onChange={handleCreateAnnouncementType} className="universal-input" readOnly required />
                  <Form.Control.Feedback type="invalid">Announcement type is requird</Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Announcment Description</Form.Label>
                  <Form.Control name={"announceDesc"} value={announcementCreate.announceDesc} placeholder={"Enter asserts id here"} onChange={handleCreateAnnouncementType} className="universal-input" required />
                  <Form.Control.Feedback type="invalid">Announcement description is requird</Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Upload File</Form.Label>
                  <Form.Control type="file" name={"announceImage"} onChange={handleAnnFileChange} className="universal-input" required={isEditAnnType ? false : true} />
                  <Form.Control.Feedback type="invalid">Announcement image is requird</Form.Control.Feedback>
                </Form.Group>
                {announcementCreate.announceIcon ? <img src={announcementCreate.announceIcon} width={"150px"} height={"150px"} alt="preview" /> : null}
              </Col>

              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Color Code</Form.Label>
                  <HexColorPicker color={color} onChange={handleColorCode} style={{ width: "100%", height: "200px" }} />
                  {colorError ? <span style={{ color: "red" }} className="font-13">Color code is requird</span> : null}
                </Form.Group>
              </Col>

              <Col sm="12" className="mt-2">
                <Form.Group>
                  <Form.Label className="color-white">If you want Enable Photo?</Form.Label>
                  <Switch name="isEnableFile" checked={announcementCreate.isEnableFile === "1"} onChange={(event, checked) => handleAnnIsFileEnable(checked)} />
                </Form.Group>
              </Col>
            </Row>
          </DialogContent>
        </Form>
      </Dialog>

      <ToastContainer position="top-right" autoClose={2000} className="toast-custom" />
    </div>
  );
};

export default AddNotification;